import React from 'react';
import { styled } from '@linaria/react';

import Demo, { DemoRadioControl } from '@/components/Demo';
import ToggleButton from '@/components/ToggleButton';
import InlineCode from '@/components/InlineCode';

import AutoRotate from './AutoRotate';

function FoldOriginDemo() {
  const [enableSpin, setEnableSpin] = React.useState(false);

  return (
    <Demo
      id="transform-origin"
      initialValues={{
        originX: 'center',
        originY: 'center',
      }}
      controlPosition="top"
      customGrid={{
        gridTemplateColumns: '100%',
        justifyContent: 'center',
      }}
      controls={[
        <DemoRadioControl
          key="originY"
          id="originY"
          label="Origin"
          options={[
            { label: 'Top', value: 'top' },
            { label: 'Center', value: 'center' },
            { label: 'Bottom', value: 'bottom' },
          ]}
        />,
      ]}
      renderAltControls={() => {
        return (
          <ToggleButton
            active={enableSpin}
            handleToggle={() => setEnableSpin(!enableSpin)}
            style={{ width: 'max-content', marginInline: 'auto' }}
          >
            Enable Rotation
          </ToggleButton>
        );
      }}
    >
      {({ originY }) => {
        return (
          <Wrapper>
            <div
              style={{
                paddingBottom: 32,
              }}
            >
              <InlineCode
                style={{
                  position: 'relative',
                  zIndex: 2,
                  fontSize: '1.3125rem',
                  mixBlendMode: 'revert',
                }}
              >
                transform-origin: {originY} center;
              </InlineCode>
            </div>
            <AutoRotate
              defaultRotation={0}
              enabled={enableSpin}
              style={{ transformOrigin: `${originY} center` }}
            >
              <img
                width="100%"
                src="/images/folding-the-dom/cats.jpg"
                alt="cats in a basket"
                style={{ maxWidth: 400 }}
              />
            </AutoRotate>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  perspective: 1200px;
`;

export default FoldOriginDemo;
